/** The peer colours, by their index: the `--peer-N-color-rgb` of `setPeerColors` */
export const DialogColors = ['red', 'orange', 'violet', 'green', 'cyan', 'blue', 'pink'] as const;
